import { isEmpty } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { fetchRoomsList, fetchStoresList } from '../actions'
import { useStoreSelector } from '@ublique/platform'
//import { STORE_ROLE } from '../FeedbackUtente/constants'
import { storeCollaborationStore } from '../state'

const formatList = (items) => items.map(({ id, title }) => ({ id, title }))
const formatRoomList = (items) =>
  items.map(({ id, title }) => ({ id, text: title }))

function useFilters(selectedStore) {
  const [storesList, setStoresList] = useState([])
  const [loading, setLoading] = useState(false)

  const user = useStoreSelector('user', (state) => state)
  //const isStoreRole = user?.roles?.includes(STORE_ROLE)

  const getStoresList = useCallback(async () => {
    /*  if (isStoreRole) {
      setStoresList([{ id: user.negozi, title: user.negozi }])
    } */
    try {
      const stores = await fetchStoresList()
      if (!isEmpty(stores)) {
        setStoresList(formatList(stores))
      }
    } catch (error) {
      console.error(error)
    }
  }, [user /* , isStoreRole */])

  const getRoomsList = useCallback(async (selectedStore) => {
    setLoading(true)
    try {
      const rooms = await fetchRoomsList(selectedStore)
      if (!isEmpty(rooms)) {
        storeCollaborationStore.update((prev) => ({
          ...prev,
          filters: { ...prev.filters, allRooms: formatRoomList(rooms) }
        }))
      }
    } catch (error) {
      console.warn(error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getStoresList()
  }, [getStoresList])

  useEffect(() => {
    if (!isEmpty(selectedStore)) {
      getRoomsList(selectedStore)
    }
  }, [getRoomsList, selectedStore])

  return {
    storesList,
    loading
    //isStoreRole
  }
}

export default useFilters
